'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        overlayFilter: 'blur(7px)'
    };
};